import InternalStaticAnchor from 'models/application/anchor/types/internalStatic/InternalStatic';

export default class InternalStaticAnchorKnowledgeBase extends InternalStaticAnchor {
	_pattern = '/knowledge-base';
}
